import styles from "./loading.module.css";

const Loading = () => {
    return (
        <div className={styles.loadingContainer}>
            {/* Spinner wrapper (only the border spins) */}
            <div className={styles.spinner}></div>

            {/* Inner Content (remains static) */}
            <div className={styles.loadingContent}>
                <img className={styles.image} src={`${process.env.PUBLIC_URL}/images/logo.png`}
                    alt="TuS05-Logo" />

                <p className={styles.text}>Die Nachrichten werden geladen</p>
            </div>
        </div>
    );
};

export default Loading;


